import React, { FC, memo, useMemo } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { Project, Team } from '@brg/api';
import { CreateLinkTo } from '../../../constants/linkTo';
import { LayoutConst } from "../../../../core";
import { AppTester } from 'supporting';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';

const ProjectDesignerWrapper = styled(FInter.Text)<{ notLink?: boolean }>`
  font-size: inherit;
  line-height: inherit;
  cursor: ${p => p?.notLink ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 600;
  color: ${({ theme }) => theme.projectView.authorText};

  ${p => p?.notLink ? null : css`
    &:hover {
      color: ${(p) => p.theme.projectView.authorColorHover};
    }
  `};


  // @media (max-width: 940px) {
    //   color: ${({ theme }) => theme.projectView.authorTextMobile};
  //   &:hover {
    //     color: ${(p) => p.theme.projectView.authorColorHoverMobile};
  //   }
  // }
`;

export const ProjectHeaderRoot = styled(FlexBox)<{ isProjectPage?: boolean, isBookPage?: boolean }>`
  display: block;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
  white-space: break-spaces;

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 13px;
  //   line-height: 18px;
  // }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};

    .ProjectHeaderMadeBy {
      font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
      line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
    }
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.s.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.s.lineHeight};

    .ProjectHeaderMadeBy {
      font-size: ${({ theme }) => theme.navigationBar.font.s.fontSize};
      line-height: ${({ theme }) => theme.navigationBar.font.s.lineHeight};
    }
  }

  ${({ isBookPage }) => isBookPage ? css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 888px;
      margin: 0 auto 16px auto;
      width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 100%;
    }
  ` : null};

  @media (max-width: 940px) {
    margin-bottom: 0;
    // margin-top: 16px;
    padding: 0 10px 0 0;

    * {
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
    }

    .ProjectHeaderMadeBy {
      font-size: 13px;
      line-height: 16px;
    }
  }

  ${({ isProjectPage }) => isProjectPage ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      padding: 0 10px 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
      padding: 0 10px 0 0;
      padding-top: 0;
    }
  ` : null};

  span {
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: inherit;
      line-height: inherit;
    }

    @media (max-width: 940px) {
      font-size: inherit;
      line-height: inherit;
      // font-weight: 700 !important;

    }
  }

  .ProjectHeaderMadeByOuter {
    margin-left: 5px;
  }

  .ProjectHeaderMadeBy {
    @media (max-width: 940px) {
      // font-weight: 400 !important;
    }
  }
`;

const MadeBy = styled(FInter.Text)`
  // font-size: 17px;
  // line-height: 32px;
  font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
  margin-right: 5px;
  color: ${({ theme }) => theme.projectView.authorCuratorText};
  // @media (max-width: 940px) {
    //   color: ${(p) => p.theme.projectView.authorTextMobile};
  // }
`;

type PropsT = {
  team: ComputedTeam | Team;
  fireClick?: boolean;
  isProjectPage?: boolean;
  isBookPage?: boolean;
};

const TeamHeader: FC<PropsT> = ({ team, fireClick, isProjectPage, isBookPage }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isOnlines = AppTester.isOnlines();

  const ownersList = useMemo(
    () => {
        //@ts-ignore
      const owners = (team?.owners ? [...team.owners] : []);

      return (owners).map((owner, index) => (
        <ProjectDesignerWrapper
          key={owner.designerId}
          notLink={isOnlines || fireClick}
        >
          {(isOnlines || fireClick) ? (
            <span>
                {`${owner.name || 'unnamed'} ${owner.surName || 'user'}`}
            </span>
          ) : (
            <Link to={CreateLinkTo.designerNew(owner)}>
              {`${owner.name || 'unnamed'} ${owner.surName || 'user'}`}
            </Link>
          )}
          {/* {index !== owner.length - 1 && (
            <span>
            {', '}
          </span>
          )} */}
        </ProjectDesignerWrapper>
      ));
    },
    [history, team],
  );

  return team ? (
    <ProjectHeaderRoot className="ProjectHeaderRoot" align="center" isProjectPage={isProjectPage} isBookPage={isBookPage}>
      {ownersList}
    </ProjectHeaderRoot>
  ) : null;
};

export default memo(TeamHeader)
import React, { FC, memo, useMemo } from 'react';
import { FInter, FlexBox } from '@brg/ui';
import { Link, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled, { css } from 'styled-components';
import { Project, Team } from '@brg/api';
import { CreateLinkTo } from '../../../constants/linkTo';
import { LayoutConst } from "../../../../core";
import { AppTester } from 'supporting';
import { ComputedTeam } from 'shared/helpers/types/computed/ComputedTeam';

const ProjectDesignerWrapper = styled(FInter.Text)<{ notLink?: boolean }>`
  font-size: inherit;
  line-height: inherit;
  cursor: ${p => p?.notLink ? 'default' : 'pointer'};
  transition: all 0.2s;
  font-weight: 600;
  color: ${({ theme }) => theme.projectView.authorText};

  ${p => p?.notLink ? null : css`
    &:hover {
      color: ${(p) => p.theme.projectView.authorColorHover};
    }
  `};


  // @media (max-width: 940px) {
    //   color: ${({ theme }) => theme.projectView.authorTextMobile};
  //   &:hover {
    //     color: ${(p) => p.theme.projectView.authorColorHoverMobile};
  //   }
  // }
`;

export const ProjectHeaderRoot = styled(FlexBox)<{ isProjectPage?: boolean, isBookPage?: boolean }>`
  display: block;
  margin-bottom: 16px;
  font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
  white-space: break-spaces;

  // @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
  //   font-size: 13px;
  //   line-height: 18px;
  // }

  @media(max-width: ${LayoutConst.screen.l_16}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};

    .ProjectHeaderMadeBy {
      font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
      line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
    }
  }

  @media(max-width: ${LayoutConst.screen.mac13}px) {
    font-size: ${({ theme }) => theme.navigationBar.font.s.fontSize};
    line-height: ${({ theme }) => theme.navigationBar.font.s.lineHeight};

    .ProjectHeaderMadeBy {
      font-size: ${({ theme }) => theme.navigationBar.font.s.fontSize};
      line-height: ${({ theme }) => theme.navigationBar.font.s.lineHeight};
    }
  }

  ${({ isBookPage }) => isBookPage ? css`
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      max-width: 888px;
      margin: 0 auto 16px auto;
      width: 100%;
    }

    @media (max-width: ${LayoutConst.screen.l_12}px) {
        max-width: 100%;
    }
  ` : null};

  @media (max-width: 940px) {
    margin-bottom: 0;
    // margin-top: 16px;
    padding: 0 10px 0 0;

    * {
      font-weight: 700;
      font-size: 13px;
      line-height: 16px;
    }

    .ProjectHeaderMadeBy {
      font-size: 13px;
      line-height: 16px;
    }
  }

  ${({ isProjectPage }) => isProjectPage ? css`
    @media(max-width: ${LayoutConst.screen.md}px) {
      padding: 0 10px 0 10px;
    }

    @media(max-width: ${LayoutConst.screen.s}px) {
      padding: 0 10px 0 0;
      padding-top: 0;
    }
  ` : null};

  span {
    @media (max-width: ${LayoutConst.screen.mac13}px), (max-height: ${LayoutConst.screen.height.projectCover}px) {
      font-size: inherit;
      line-height: inherit;
    }

    @media (max-width: 940px) {
      font-size: inherit;
      line-height: inherit;
      // font-weight: 700 !important;

    }
  }

  .ProjectHeaderMadeByOuter {
    margin-left: 5px;
  }

  .ProjectHeaderMadeBy {
    @media (max-width: 940px) {
      // font-weight: 400 !important;
    }
  }
`;

const MadeBy = styled(FInter.Text)`
  // font-size: 17px;
  // line-height: 32px;
  font-size: ${({ theme }) => theme.navigationBar.font.m.fontSize};
  line-height: ${({ theme }) => theme.navigationBar.font.m.lineHeight};
  margin-right: 5px;
  color: ${({ theme }) => theme.projectView.authorCuratorText};
  // @media (max-width: 940px) {
    //   color: ${(p) => p.theme.projectView.authorTextMobile};
  // }
`;

type PropsT = {
  team: ComputedTeam | Team;
  fireClick?: boolean;
  isProjectPage?: boolean;
  isBookPage?: boolean;
};

const TeamHeader: FC<PropsT> = ({ team, fireClick, isProjectPage, isBookPage }) => {
  const { t } = useTranslation();
  const history = useHistory();
  const isOnlines = AppTester.isOnlines();

  const ownersList = useMemo(
    () => {
        //@ts-ignore
      const owners = (team?.owners ? [...team.owners] : []);

      return (owners).map((owner, index) => (
        <ProjectDesignerWrapper
          key={owner.designerId}
          notLink={isOnlines || fireClick}
        >
          {(isOnlines || fireClick) ? (
            <span>
                {`${owner.name || 'unnamed'} ${owner.surName || 'user'}`}
            </span>
          ) : (
            <Link to={CreateLinkTo.designerNew(owner)}>
              {`${owner.name || 'unnamed'} ${owner.surName || 'user'}`}
            </Link>
          )}
          {/* {index !== owner.length - 1 && (
            <span>
            {', '}
          </span>
          )} */}
        </ProjectDesignerWrapper>
      ));
    },
    [history, team],
  );

  return team ? (
    <ProjectHeaderRoot className="ProjectHeaderRoot" align="center" isProjectPage={isProjectPage} isBookPage={isBookPage}>
      {ownersList}
    </ProjectHeaderRoot>
  ) : null;
};

export default memo(TeamHeader)
